// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconQuoteClose = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M30 27C30 46.7776 14.5202 54.0001 9.33655 54.0001C7.97028 54.0001 7.40485 52.6616 8.83533 51.8033C12.5428 49.5788 18 43.688 18 38C10.5955 38 6 33.0215 6 25C6 16.9785 10.5955 12 18 12C25.4045 12 30 17.5295 30 27ZM46 12C38.5955 12 34 16.9785 34 25C34 33.0215 38.5955 38 46 38C46 43.688 40.5428 49.5788 36.8353 51.8033C35.4048 52.6616 35.9703 54.0001 37.3365 54.0001C42.5202 54.0001 58 46.7776 58 27C58 17.5295 53.4045 12 46 12Z" />
    </svg>
  );
};
